import axios, { AxiosRequestHeaders } from "axios";
import { decodeAuthToken } from "../components/utils";
import { useAuthStore } from "../store";

const hissaApi = axios.create({
  baseURL:
    sessionStorage.getItem("apiUrl") ||
    process.env.REACT_APP_API ||
    "http://localhost:8080",
});

hissaApi.defaults.headers.post["Content-Type"] = "application/json";

hissaApi.interceptors.request.use((config) => {
  if (config.url?.includes("isBlob=true")) {
    config.responseType = "blob";
    config.url = config.url.split("?isBlob=true")[0];
  }
  const companyId = sessionStorage.getItem("companyId") || "";
  const accesstoken =
    sessionStorage.getItem("accesstoken") || useAuthStore.getState().accessToken;
  if (accesstoken && !config.url?.endsWith("/login")) {
    (config.headers as AxiosRequestHeaders).companyId = companyId;
    (config.headers as AxiosRequestHeaders).AccessToken = accesstoken;
  }
  // use X-USR-TOKEN for logout only
  if (config.url === "exit") {
    (config.headers as AxiosRequestHeaders)["x-user-token"] = decodeAuthToken(
      accesstoken || ""
    ).xUserToken;
    delete (config.headers as AxiosRequestHeaders).AccessToken;
  }
  return config;
});

export default hissaApi;
